export interface VaccineTypeValue {
  id: string;
  value: string;
}

interface VaccineTypeProps {
  [key: string]: VaccineTypeValue
}

export const vaccineType: VaccineTypeProps = {
  VACINA: {
    id: 'vaccine',
    value: 'Vacina',
  },
  VERMIFUGO: {
    id: 'vermifuge',
    value: 'Vermífugo',
  },
}

export const vaccineTypeOptions = Object.keys(vaccineType).map((key: string) => vaccineType[key])
